import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Utilities from "../../dependencies/custom/react-utilities";
import domainSettings from "../../dependencies/custom/settings";

export const useDistributions = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const markCollected = useCallback(
    async (distributionId, data) => {
      setLoading(true);
      try {
        const url = domainSettings.urls.bot.markCollected.replace(
          ":id",
          distributionId,
        );
        const response = await Utilities.fetchWithAuth(
          "POST",
          url,
          data,
          navigate,
        );

        if (response.ok) {
          message.success("Item marked as collected");
          return response.data;
        } else {
          Utilities.showError(response, "Failed to mark as collected");
          return null;
        }
      } catch (error) {
        message.error("An error occurred while marking item as collected");
        console.error(error);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [navigate],
  );

  const verifyDistribution = useCallback(
    async (distributionId, data) => {
      setLoading(true);
      try {
        const url = domainSettings.urls.bot.verifyDistribution.replace(
          ":id",
          distributionId,
        );
        const response = await Utilities.fetchWithAuth(
          "POST",
          url,
          data,
          navigate,
        );

        if (response.ok) {
          message.success("Item verified successfully");
          return response.data;
        } else {
          Utilities.showError(response, "Failed to verify item");
          return null;
        }
      } catch (error) {
        message.error("An error occurred while verifying item");
        console.error(error);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [navigate],
  );

  return {
    loading,
    markCollected,
    verifyDistribution,
  };
};
